import About from '@components/pages/About'
import Terms from '@components/pages/Terms'
import Privacy from '@components/pages/Privacy'
import Contact from '@components/pages/Contact'
import Support from '@components/pages/Support'

/**
 * Route configuration for STATIC PAGES only
 * Game screens are handled by App.jsx orchestrators
 */

export const ROUTE_CONFIG = {
  // Static pages
  about: {
    component: About,
    layout: { header: true, footer: 'conditional' }
  },
  terms: {
    component: Terms,
    layout: { header: true, footer: 'conditional' }
  },
  privacy: {
    component: Privacy,
    layout: { header: true, footer: 'conditional' }
  },
  contact: {
    component: Contact,
    layout: { header: true, footer: 'conditional' }
  },
  support: {
    component: Support,
    layout: { header: true, footer: 'conditional' }
  }
}
